<template>
  <v-app-bar
    :color="appBarColor"
    flat
    hide-on-scroll
    :extension-height="extensionHeight"
    :extended="hasSlot"
    app
  >
    <img
      :width="100"
      src="../../assets/logo_mini.png"
      @click="$router.replace('/home')"
    >
    <v-toolbar-title
      v-if="!$mobileDetect.phone() && !$mobileDetect.tablet()"
      class="brand-toolbar-title text-uppercase font-weight-bold primary--text ml-0"
      style="text-align: center; font-size: 23px;"
    >
      {{ $t('app.invoices') }}
      <div
        class="subheading"
        style="font-size: 8px!important; text-align: center"
      >
        {{ email }}
      </div>
    </v-toolbar-title>
    <v-tabs
      v-model="activeTab"
      centered
      show-arrows
      color="transparent"
      slider-color="primary"
    >
      <v-tab
        exact
        to="/home"
        class="text-uppercase primary--text"
        :ripple="false"
      >
        <span
          v-if="!$mobileDetect.phone()"
          class="title"
        >{{ $t('app.myInvoices') }}</span>
        <v-icon
          v-else
          class="primary--text"
          medium
        >
          fas fa-file-invoice
        </v-icon>
      </v-tab>
      <v-tab
        exact
        to="/account"
        class=" text-uppercase primary--text"
        :class="{ 'mr-5': !$mobileDetect.phone(), 'ml-5': !$mobileDetect.phone() }"
        :ripple="false"
      >
        <span
          v-if="!$mobileDetect.phone()"
          class="title"
        >{{ $t('app.editPassword') }}</span>
        <v-icon
          v-else
          class="primary--text"
          medium
        >
          fas fa-key
        </v-icon>
      </v-tab>
      <v-tab
        exact
        class="text-uppercase primary--text"
        :ripple="false"
        @click="openLogOffModal"
      >
        <span
          v-if="!$mobileDetect.phone()"
          class="title"
        >{{ $t('app.logOff') }}</span>
        <v-icon
          v-else
          class="primary--text"
          medium
        >
          fas fa-power-off
        </v-icon>
      </v-tab>
    </v-tabs>
    <v-spacer />
    <v-dialog
      v-model="logOffModalOpen"
      persistent
      width="300"
      content-class="dialog-radius"
    >
      <v-card>
        <v-card-title class="headline">
          <v-spacer />
          {{ $t('app.sureLogOff') }}
          <v-spacer />
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            rounded
            @click="$store.commit('LOGOFF')"
          >
            {{ $t('app.yes') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            rounded
            @click="cancelLogOff()"
          >
            {{ $t('app.no') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-slot:extension>
      <slot name="filters" />
    </template>
  </v-app-bar>
</template>

<script>
// TODO : SET Show Accounts Selector in Store
  export default {
    name: 'NavbarApp',
    data () {
      return {
        logOffModalOpen: false,
        activeTab: null,
        appBarDisplayed: true,
        appBarColor: 'transparent',
      }
    },
    computed: {
      email () {
        return this.$store.state.user.email
      },
      hasSlot () {
        return !!this.$slots.filters || !!this.$scopedSlots.filters
      },
      extensionHeight () {
        let value = this.hasSlot ? 75 : 0
        if (this.$store.state.accounts.list.length > 1 && this.$mobileDetect.phone() && this.hasSlot) {
          value += 48
        }
        return value
      },
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll (event) {
        if (window.scrollY === 0) {
          this.appBarColor = 'transparent'
        } else {
          this.appBarColor = undefined
        }
      },
      openLogOffModal () {
        this.logOffModalOpen = true
      },
      cancelLogOff () {
        this.logOffModalOpen = false
        this.activeTab = this.$router.currentRoute.path
      },
    },
  }
</script>
<style>
img {
  cursor: pointer
}
.brand-toolbar-title {
  font-size: 40px;
  width: 300px !important;
}
</style>
